export const TEST_ID = {
  dashboard: 'dashboard',
  services: 'services',
  adminServices: 'adminServices',
};
